// Fonte: UManutContas.pas — DSColigado, lógica em EditCodigo_ContaExit e BitBtn11Click
// Tabela: Coligados (PK: Codigo_Conta + CGC + codigo_grupo_empresa)
import React, { useState, useEffect, useCallback } from 'react';
import { Table, Button, Form, Modal, Spinner, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
  listarColigadosConta,
  inserirColigadoConta,
  excluirColigadoConta,
} from '~/Services/Service';
import aplicarMascara from '../components/mascaras';

var TabColigados = function(_ref) {
  var ge = _ref.ge;
  var codigo = _ref.codigo;

  var [lista, setLista] = useState([]);
  var [loading, setLoading] = useState(false);
  var [showModal, setShowModal] = useState(false);
  var [cpf, setCpf] = useState('');
  var [salvando, setSalvando] = useState(false);
  var [showExcluir, setShowExcluir] = useState(null);

  var carregar = useCallback(function() {
    if (!ge || !codigo) return;
    setLoading(true);
    listarColigadosConta(ge, codigo)
      .then(function(resp) {
        setLista(Array.isArray(resp) ? resp : []);
      })
      .catch(function() { toast.error('Erro ao carregar coligados'); })
      .finally(function() { setLoading(false); });
  }, [ge, codigo]);

  useEffect(function() { carregar(); }, [carregar]);

  var handleIncluir = function() {
    if (!cpf) { toast.warning('Informe o CPF/CNPJ'); return; }
    // DW-0963: CGC pode ser CNPJ alfanumérico — normaliza preservando letras (uppercase),
    // sem Number()/\D-strip (que apagariam A-Z e gerariam NaN). Back (T40/T50) recebe string.
    const cgcLimpo = String(cpf).toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (!cgcLimpo) { toast.warning('CPF/CNPJ inválido'); return; }
    setSalvando(true);
    inserirColigadoConta(ge, codigo, { cgc: cgcLimpo })
      .then(function() {
        toast.success('Coligado incluído!');
        setShowModal(false);
        setCpf('');
        carregar();
      })
      .catch(function() { toast.error('Erro ao incluir coligado'); })
      .finally(function() { setSalvando(false); });
  };

  var handleExcluir = function() {
    // DW-0963: Cgc do coligado vem como string do back (ContaColigadoResponse.Cgc);
    // normaliza preservando letras (uppercase), sem Number()/\D-strip. Back recebe string
    // (ContaColigadoExcluirRequest.Cgc agora é string — Fase 3).
    const cgcStr = String(showExcluir.cgc || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    excluirColigadoConta(ge, codigo, { cgc: cgcStr })
      .then(function() {
        toast.success('Coligado removido!');
        setShowExcluir(null);
        carregar();
      })
      .catch(function() { toast.error('Erro ao remover coligado'); });
  };

  return (
    <div className="contas-tab-content">
      <div className="d-flex justify-content-end mb-2">
        <Button size="sm" variant="primary" onClick={function() { setShowModal(true); }}>+ Incluir Coligado</Button>
      </div>
      {loading ? (
        <div className="text-center py-3"><Spinner animation="border" /></div>
      ) : (
        <Table size="sm" bordered className="contas-sub-grid">
          <thead>
            <tr>
              <th>Código Conta</th>
              <th>CPF/CNPJ</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {lista.length === 0 ? (
              <tr><td colSpan={3} className="text-center text-muted">Nenhum coligado</td></tr>
            ) : (
              lista.map(function(item, i) {
                return (
                  <tr key={item.cgc ? item.cgc + '_' + item.codigo_conta : 'col_' + i}>
                    <td>{item.codigo_conta}</td>
                    <td>{item.cgc}</td>
                    <td>
                      <Button size="sm" variant="outline-danger"
                        onClick={function() { setShowExcluir(item); }}>
                        Remover
                      </Button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      )}

      <Modal show={showModal} onHide={function() { setShowModal(false); }}>
        <Modal.Header closeButton className="contas-modal-header"><Modal.Title>Incluir Coligado</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label className="small">CPF/CNPJ</Form.Label>
            <Form.Control
              type="text" size="sm"
              value={aplicarMascara(cpf, 'cpf')}
              onChange={function(e) { setCpf(aplicarMascara(e.target.value, 'cpf')); }}
              maxLength={18}
              placeholder="Informe o CPF ou CNPJ..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowModal(false); }}>Cancelar</Button>
          <Button variant="success" onClick={handleIncluir} disabled={salvando}>
            {salvando ? <Spinner animation="border" size="sm" /> : 'Incluir'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={!!showExcluir} onHide={function() { setShowExcluir(null); }}>
        <Modal.Header closeButton className="contas-modal-header"><Modal.Title>Confirmar Remoção</Modal.Title></Modal.Header>
        <Modal.Body>Deseja remover o coligado com CPF/CNPJ <strong>{showExcluir && showExcluir.cgc}</strong>?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowExcluir(null); }}>Não</Button>
          <Button variant="danger" onClick={handleExcluir}>Remover</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TabColigados;
